<template>
	<div>
		<div class="container mt-4">
			<div
				class="row align-items-center justify-content-center flex-column"
			>
				<div class="col">
					<template v-if="filtered_groups.length > 0">
						<div
							class="select-all-wrapper mb-3 d-flex align-items-center"
						>
							<div class="form-check">
								<input
									type="checkbox"
									class=""
									:id="'select-all-groups'"
									:checked="allSelected"
									@change="ToggleSelectAll"
									hidden
								/>
								<label
									class="form-check-label ml-3"
									:for="'select-all-groups'"
								>
								</label>
							</div>
							<p>TODOS</p>
						</div>
						<div class="materials-container">
							<div
								v-for="(group, index) in filtered_groups"
								:key="group.id"
								class="materials-wrapper"
								:class="{
									active:
										selected.group &&
										group.id === selected.group.id,
								}"
							>
								<div class="form-check">
									<input
										type="checkbox"
										class=""
										:id="'group-' + group.id + '-' + index"
										:name="
											'group-' + group.id + '-' + index
										"
										:checked="group.selected"
										@change="SelectGroup(group)"
										hidden
									/>
									<label
										class="form-check-label ml-3"
										:for="'group-' + group.id + '-' + index"
									>
									</label>
								</div>
								<div
									class="list-tile rounded-lg border p-2"
									@click="Select(group)"
								>
									<div class="form-row align-items-center">
										<div class="flex items-center">
											<div
												class="mx-2 col-auto font-40 px-2"
												:class="{
													'text-primary':
														group.status,
													'text-secondary':
														!group.status,
												}"
											>
												<i
													class="fad cursor-pointer"
													:class="{
														'fa-toggle-on':
															group.status,
														'fa-toggle-off':
															!group.status,
													}"
													@click.stop="
														ToggleGroup([group.id])
													"
												></i>
											</div>
										</div>
										<div class="col pl-3">
											{{ group.name.toUpperCase() }}
										</div>
										<div class="col-auto">
											<button
												class="btn btn-outline-edit"
												@click.stop="Edit(group)"
											>
												<i class="fas fa-pen"></i>
											</button>
										</div>
										<div class="col-auto">
											<button
												class="btn btn-outline-chevron"
											>
												<i
													class="far fa-chevron-right"
												></i>
											</button>
										</div>
									</div>
								</div>
								<div class="flex items-center actions">
									<button
										class="btn btn-unshaped btn-outline-danger font-24"
										@click.stop="DeleteGroup(group.id)"
									>
										<i class="fal fa-trash"></i>
									</button>
								</div>
							</div>
						</div>
					</template>
					<template v-else>
						<p class="text-muted text-center">Não há grupos</p>
					</template>
				</div>
			</div>
		</div>
		<div
			class="modal fade"
			id="modal-group"
		>
			<div class="modal-dialog">
				<div class="modal-content">
					<div
						class="modal-header px-5 py-4"
						style="display: flex; justify-content: center"
					>
						<h4 class="font-20 m-0">
							{{ form.id ? 'EDITAR' : 'NOVO' }} GRUPO
						</h4>
						<button
							type="button"
							class="position-absolute btn btn-light p-3 ps-r-0 ps-t-0 m-3"
							data-dismiss="modal"
						>
							<i class="far fa-times mx-1"></i>
						</button>
					</div>
					<hr class="m-0" />
					<div class="modal-body">
						<div class="form-row p-4 justify-content-center">
							<div class="col-12">
								<div class="form-group">
									<MaterialTypeCheckboxes
										:value="form.material_type"
										:disabled="type_locked"
										@input="form.material_type = $event"
									/>
								</div>
							</div>
							<div class="col-12">
								<div class="form-group">
									<input
										type="text"
										placeholder="NOME"
										v-model="form.name"
										@input="
											form.name =
												$event.target.value.toUpperCase()
										"
										class="form-control"
									/>
								</div>
							</div>
							<div class="col-12">
								<div class="form-group">
									<label>DESCRIÇÃO</label>
									<Editor v-model="form.instructions" />
								</div>
							</div>
						</div>
						<hr class="m-0" />
						<div class="d-flex justify-content-between p-4">
							<button
								class="btn btn-danger p-3 px-4"
								data-dismiss="modal"
							>
								CANCELAR
							</button>

							<button
								class="btn btn-success p-3 px-4"
								@click="Save()"
							>
								SALVAR
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex'
	import { useConfirmation, useDeleteAlert, useError, useEachRecursively, useMaterialTypeWarning } from '@/composables'
	import Editor from '@/components/shared/Editor'
	import MaterialTypeCheckboxes from './MaterialTypeCheckboxes.vue'

	const _ = require('lodash')

	export default {
		name: 'MaterialGroup',
		props: {
			label: {
				type: String,
				default: '',
			},
			groups: {
				type: Array,
				default: () => [],
			},
			group_id: {
				type: [String, Number],
				default: null,
			},
		},
		components: {
			Editor,
			MaterialTypeCheckboxes,
		},
		data() {
			return {
				selected: {
					group: null,
				},
				originalMaterialType: null,
				type_locked: false,
				type_locked_level: null,
				form: {
					id: '',
					name: '',
					instructions: '',
					type: 1,
					material_type: {
						material: true,
						medical: false,
						opme: false,
						medical_gas: false,
					},
				},
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			filtered_groups() {
				return _.sortBy(this.groups, 'name', 'asc')
			},
			allSelected() {
				if (!this.filtered_groups || this.filtered_groups.length === 0)
					return false
				return this.filtered_groups.every(g => g.selected)
			},
		},
		watch: {
			group_id: {
				handler(val) {
					if (val) {
						this.selected.group = this.groups.find(
							m => m.id === parseInt(val)
						)
					}
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			Previous() {
				this.$emit('previous')
			},
			ToggleSelectAll() {
				const newVal = !this.allSelected
				const groups = this.groups.map(g => ({
					...g,
					selected: newVal,
				}))
				this.$emit('update-groups', groups)
			},
			Select(group) {
				this.$emit('next', group)
			},
			SelectGroup(group) {
				group.selected = !group.selected
				this.$emit('update-groups', [...this.groups])
			},
			New(materialType = null, locked = false, level = null) {
				this.form.id = ''
				this.form.name = ''
				this.form.instructions = ''
				this.form.material_type = materialType
					? { ...materialType }
					: {
							material: true,
							medical: false,
							opme: false,
							medical_gas: false,
					  }
				this.type_locked = !!locked
				this.type_locked_level = locked ? level : null

				window.jQuery('#modal-group').modal('show')
			},
			Edit(group) {
				this.form.id = group.id
				this.form.name = group.name
				this.form.instructions = group.instructions
				this.form.material_type = group.material_type
					? { ...group.material_type }
					: {
							material: true,
							medical: false,
							opme: false,
							medical_gas: false,
					  }
				this.originalMaterialType = { ...this.form.material_type }
				this.type_locked = !!group._type_locked
				this.type_locked_level = group._type_locked ? group._type_locked_level : null

				window.jQuery('#modal-group').modal('show')
			},
			Close() {
				window.jQuery('.modal').modal('hide')
			},
			async Save() {
				if (this.form.id && !_.isEqual(this.originalMaterialType, this.form.material_type)) {
					if (!(await useMaterialTypeWarning())) return
				}

				this.StartLoading()

				return window.api
					.call('post', '/save-material', {
						organization_id: this.requester_selected_id,
						...this.form,
						type_locked: this.type_locked,
						type_locked_level: this.type_locked_level,
					})
					.then(({ data }) => {
						if (data.response) {
							let groups = this.groups
							const materialType = { ...this.form.material_type }
							const locked = !materialType.material

							if (this.form.id) {
								groups = groups.map(g => {
									if (g.id == this.form.id) {
										g.name = data.material.name
										g.instructions =
											data.material.instructions
										g.material_type = materialType

										useEachRecursively(g.children ?? [], child => {
											child.material_type = { ...materialType }
											child._type_locked = locked
											child._type_locked_level = locked
												? 'group'
												: null
										})
									}

									return g
								})
							} else {
								groups.push({
									...data.material,
									material_type: materialType,
									_type_locked: this.type_locked,
									_type_locked_level: this.type_locked_level,
								})
							}

							this.$emit('update-groups', groups)
						}
					})
					.finally(() => {
						window.jQuery('.modal').modal('hide')
						this.FinishLoading()
					})
			},
			async DeleteGroup(id) {
				if (!id) return

				useDeleteAlert().then(async result => {
					if (result.isConfirmed) {
						this.StartLoading()

						await window.api
							.call('post', '/delete-material', {
								organization_id: this.requester_selected_id,
								material_id: id,
							})
							.then(({ data }) => {
								if (data.response) {
									useConfirmation()

									this.$emit(
										'update-groups',
										this.groups.filter(g => g.id !== id)
									)

									this.Close()
								} else {
									useError(
										'Houve um erro ao concluir, contate o suporte.'
									)
								}
							})
							.finally(() => {
								this.FinishLoading()
							})
					}
				})
			},
			ToggleGroup(ids) {
				this.StartLoading()

				window.api
					.call('post', '/toggle-material-status', {
						organization_id: this.requester_selected_id,
						material_id: ids,
					})
					.then(({ data }) => {
						if (data.response) {
							let groups = this.groups.map(g => {
								if (ids.includes(g.id)) {
									g.status = data.status
								}

								return g
							})

							this.$emit('update-groups', groups)

							ids.forEach(id => {
								this.$emit('toggle-group-status', {
									id: id,
									status: data.status,
								})
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		max-width: 100%;
	}

	.modal-dialog {
		max-width: 90%;
	}

	.select-all-wrapper {
		.form-check {
			display: flex;
			align-items: center;
			position: relative;
		}

		.form-check input[type='checkbox'] {
			display: none;
		}

		.form-check-label {
			position: relative;
			width: 2rem;
			height: 2rem;
			padding: 0;
			background: var(--inputBackgroundLight, #222);
			border-radius: 0.5rem;
			display: block;
		}

		.form-check input[type='checkbox']:checked + .form-check-label:after {
			font-family: 'Font Awesome 5 Pro';
			content: '\f00c';
			font-weight: 400;
			padding: 0.1rem 0.3rem;
			font-size: 1.3rem;
			color: #fff;
			top: 0;
			left: 0;
			position: absolute;
			width: 2rem;
			height: 2rem;
			background: var(--newPrimaryBackgroundColor);
			border-radius: 0.5rem;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.form-check-label:before {
			content: '';
			position: absolute;
			width: 2rem;
			height: 2rem;
			background: var(--elementsBackgroundColor);
			border-radius: 0.5rem;
			left: 0;
			top: 0;
		}

		.form-check:hover .form-check-label:before {
			background: var(--elementsBackgroundColor);
		}

		p {
			display: flex;
			justify-content: center;
			align-items: center;
			margin: 0;
			padding-left: 15px;
			font-weight: 600;
			color: var(--titleFontColor);
		}
	}

	.materials-container {
		display: flex;
		flex-direction: column;
		gap: 1rem;

		.materials-wrapper {
			display: flex;
			align-items: center;
			gap: 1rem;
		}

		.form-check {
			display: flex;
			align-items: center;
			position: relative;
		}

		.form-check input[type='checkbox'] {
			display: none;
		}

		.form-check-label {
			position: relative;
			width: 2rem;
			height: 2rem;
			padding: 0;
			background: var(--inputBackgroundLight, #222);
			border-radius: 0.5rem;
			display: block;
		}

		.form-check input[type='checkbox']:checked + .form-check-label:after {
			font-family: 'Font Awesome 5 Pro';
			content: '\f00c';
			font-weight: 400;
			padding: 0.1rem 0.3rem;
			font-size: 1.3rem;
			color: #fff;
			top: 0;
			left: 0;
			position: absolute;
			width: 2rem;
			height: 2rem;
			background: var(--newPrimaryBackgroundColor);
			border-radius: 0.5rem;
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.form-check-label:before {
			content: '';
			position: absolute;
			width: 2rem;
			height: 2rem;
			background: var(--elementsBackgroundColor);
			border-radius: 0.5rem;
			left: 0;
			top: 0;
		}

		.form-check:hover .form-check-label:before {
			background: var(--elementsBackgroundColor);
		}

		.materials-container {
			color: var(--fontColor, #fff);
			border-radius: 1rem;
			cursor: pointer;
			transition: background 0.2s;
		}

		.list-tile {
			background-color: transparent;
			border: 1px solid var(--elementsBorderColor) !important;
			color: var(--fontColor);

			&:hover {
				border-color: var(--newPrimaryHoverBackgroundColor) !important;
				background-color: var(--newPrimaryHoverBackgroundColor);
				color: #fff;
			}
		}

		.text-primary {
			color: var(--newPrimaryBackgroundColor) !important;
		}

		.text-dark {
			color: var(--background) !important;
		}

		.fad.fa-toggle-on:after {
			color: var(--white);
			opacity: 1;
		}

		.actions {
			display: flex;
			align-items: center;
		}

		.btn-unshaped {
			background: none;
			border: none;
			padding: 0.5rem;
			cursor: pointer;
		}

		.btn-outline-danger {
			border-radius: 0.5rem;
			font-size: 1.5rem;
			transition: background 0.2s;

			&:hover {
				background: transparent;
			}
		}

		.btn-outline-edit {
			height: 35px;
    		width: 35px;
			border-radius: 8px;
			background-color: var(--newPrimaryBackgroundColor);
    		color: var(--white);

			&:hover {
				color: var(--newPrimaryHoverColor);
				background-color: var(--light);
				opacity: 0.7;
			}
		}

		.btn-outline-chevron {
			height: 35px;
    		width: 35px;
			border-radius: 8px;
			background-color: var(--newPrimaryBackgroundColor);
    		color: var(--white);

			&:hover {
				color: var(--newPrimaryHoverColor);
				background-color: var(--light);
				opacity: 0.7;
			}
		}

		font-40 {
			font-size: 2rem;
		}
	}

	.btn-primary {
		--newPrimaryBackgroundColor: #2196f3;
		--newPrimaryHover: hsl(207, 90%, 35%);

		background-color: var(--newPrimaryBackgroundColor) !important;
		border-color: var(--newPrimaryBackgroundColor) !important;
		border-radius: 0.8rem !important;
		padding: 1rem 1.5rem;
		height: 2.8rem;
		font-size: 1.1rem;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 8rem;

		&:hover {
			background-color: var(--newPrimaryHover) !important;
			border-color: var(--newPrimaryHover) !important;
		}
	}

	.btn-success {
		--successBackgroundColor: #19d319;
		--newSuccessHover: hsl(120, 79%, 30%);

		background-color: var(--successBackgroundColor);
		border-color: var(--successBackgroundColor);
		border-radius: 0.8rem !important;
		padding: 1rem 1.5rem;
		height: 2.8rem;
		font-size: 1.1rem;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 8rem;

		&:hover {
			background-color: var(--newSuccessHover);
			border-color: var(--newSuccessHover);
		}
	}

	.btn-danger {
		background-color: #b71c1c !important;
		border-color: #b71c1c !important;
		border-radius: 0.8rem !important;
		padding: 1rem 1.5rem;
		height: 2.8rem;
		font-size: 1.1rem;
		font-weight: bold;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 8rem;

		&:hover {
			background-color: hsl(0, 73%, 35%) !important;
			border-color: hsl(0, 73%, 35%) !important;
		}
	}
</style>
